import React from 'react';

import { withLocation } from 'depop/contextWrappers';

class InfiniteScroll extends React.Component {
  props: {
    location: Object,
    element: string,
    hasMore: boolean,
    initialLoad: boolean,
    loadMore: () => void,
    pageStart: number,
    threshold: number,
    useWindow: boolean,
    isReverse: boolean,
    loader: ?React.Element,
    children: React.Element,
    style: ?Object,
  };

  static defaultProps = {
    element: 'div',
    hasMore: false,
    initialLoad: true,
    pageStart: 0,
    threshold: 250,
    useWindow: true,
    isReverse: false,
  };

  constructor(props) {
    super(props);
    this.scrollListener = this.scrollListener.bind(this);
  }

  componentDidMount() {
    this.pageLoaded = this.props.pageStart;
    this.attachScrollListener();
  }

  componentDidUpdate() {
    this.attachScrollListener();
  }

  render() {
    const {
      children,
      element,
      hasMore,
      loader,
      style,
    } = this.props;

    const ref = (node) => { this.scrollComponent = node; };

    const showLoader = hasMore &&
      !(this.props.location.query && this.props.location.query.hasOwnProperty('disablePaging'));

    return React.createElement(element, {style, ref}, children, showLoader && (loader || this._defaultLoader));
  }

  calculateTopPosition(el) {
    if (!el) {
      return 0;
    }
    return el.offsetTop + this.calculateTopPosition(el.offsetParent);
  }

  scrollListener() {
    const el = this.scrollComponent;
    const scrollEl = window;

    let offset;
    if (this.props.useWindow) {
      var scrollTop = (scrollEl.pageYOffset !== undefined) ? scrollEl.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
      if (this.props.isReverse) {
        offset = scrollTop;
      } else {
        offset = this.calculateTopPosition(el) + el.offsetHeight - scrollTop - window.innerHeight;
      }
    } else {
      if (this.props.isReverse) {
        offset = el.parentNode.scrollTop;
      } else { offset = el.scrollHeight - el.parentNode.scrollTop - el.parentNode.clientHeight; }
    }

    if (offset < Number(this.props.threshold)) {
      this.detachScrollListener();
          // Call loadMore after detachScrollListener to allow for non-async loadMore functions
      if (typeof this.props.loadMore === 'function') {
        if (this.props.location.query && this.props.location.query.hasOwnProperty('disablePaging')) {
          return;
        }
        this.props.loadMore(this.pageLoaded += 1);
      }
    }
  }

  attachScrollListener() {
    if (!this.props.hasMore) {
      return;
    }

    let scrollEl = window;
    if (this.props.useWindow == false) {
      scrollEl = this.scrollComponent.parentNode;
    }

    scrollEl.addEventListener('scroll', this.scrollListener);
    scrollEl.addEventListener('resize', this.scrollListener);

    if (this.props.initialLoad) {
      this.scrollListener();
    }
  }

  detachScrollListener() {
    var scrollEl = window;
    if (this.props.useWindow == false) {
      scrollEl = this.scrollComponent.parentNode;
    }

    scrollEl.removeEventListener('scroll', this.scrollListener);
    scrollEl.removeEventListener('resize', this.scrollListener);
  }

  componentWillUnmount() {
    this.detachScrollListener();
  }

  // Set a defaut loader for all your `InfiniteScroll` components
  setDefaultLoader(loader) {
    this._defaultLoader = loader;
  }
}

export default withLocation(InfiniteScroll);



// WEBPACK FOOTER //
// ../src/client/components/InfiniteScroll.js